import { render, staticRenderFns } from "./StaffOnly.vue?vue&type=template&id=6c6445bd&"
import script from "./StaffOnly.vue?vue&type=script&lang=ts&"
export * from "./StaffOnly.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports